import script from "./DropdownSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownSelect.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownSelect.vue?vue&type=style&index=0&id=3134d0f9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3134d0f9"]])

export default __exports__